import React, { useState, useEffect, useRef } from "react";
import { FaTimes, FaBars, FaChevronDown, FaHeart } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useWishlist } from "../Context/WishlistContext";

// Thumbnail images for Wallpaper subcategories
const WALLPAPER_THUMBNAILS = {
  Decorative: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsdecorativemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsdecorativemain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsdecorativemain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsdecorativemain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsdecorativemain/5.jpg',
  ],
  Abstract: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsabstractmain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsabstractmain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsabstractmain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsabstractmain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsabstractmain/5.jpg',
  ],
  Corporate: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringscorporatemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringscorporatemain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringscorporatemain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringscorporatemain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringscorporatemain/5.jpg',
  ],
  Kids: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids5.jpg',
  ],
  "Minimal and Pattern": [
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern/(1).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern/(2).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern/(3).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern/(4).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern/(5).jpg',
  ],
  "View All": [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsdecorativemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringsabstractmain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/WallcoveringsThirdSlide/Wallcoveringscorporatemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/maincards/kids1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Minimal%26Pattern/(1).jpg',
  ],
};

// Thumbnail images for Art Prints subcategories
const ARTPRINT_THUMBNAILS = {
  Abstract: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsabstractmain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsabstractmain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsabstractmain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsabstractmain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsabstractmain/5.jpg',
  ],
  Decorative: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsdecorativemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsdecorativemain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsdecorativemain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsdecorativemain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsdecorativemain/5.jpg',
  ],
  Exclusive: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsexclusivemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsexclusivemain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsexclusivemain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsexclusivemain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsexclusivemain/5.jpg',
  ],
  Landscape: [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintslandscapemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintslandscapemain/2.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintslandscapemain/3.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintslandscapemain/4.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintslandscapemain/5.jpg',
  ],
  "Set of 2 and 3": [
    'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3/(1).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3/(2).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3/(3).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3/(4).jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3/(5).jpg',
  ],
  "View All": [
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsabstractmain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsdecorativemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintsexclusivemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/Components/ArtprintsFourthSlide/artprintslandscapemain/1.jpg',
    'https://vizaura.s3.eu-north-1.amazonaws.com/ArtPrints/set+of+2+and+3/(1).jpg',
  ],
};

// Small rotating square thumbnail component for mobile navigation subcategories
const CategoryRotatingThumbnail = ({ images = [], alt = "Category" }) => {
  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIdx((prev) => (prev + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) return null;

  return (
    <div className="w-10 h-10 min-w-[40px] rounded-lg overflow-hidden relative shadow-sm border border-gray-200 bg-gray-100 mr-3 flex-shrink-0">
      {images.map((src, idx) => (
        <img
          key={idx}
          src={src}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-in-out ${idx === currentIdx ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
            }`}
          loading="lazy"
        />
      ))}
    </div>
  );
};

const Navbar = () => {
  const logo = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/logo/VIZAURA-LOGO-TM.png"
  const [icon, setIcon] = useState(false);
  const [wallcoveringsSubmenuOpen, setWallcoveringsSubmenuOpen] = useState(false);
  const [artprintsSubmenuOpen, setArtprintsSubmenuOpen] = useState(false);
  const { getWishlistCount } = useWishlist();
  // Create a ref for the mobile menu container
  const mobileMenuRef = useRef(null);
  // Create a ref for the hamburger icon/button
  const menuButtonRef = useRef(null);

  const handleLinkClick = () => {
    setIcon(false);
    setWallcoveringsSubmenuOpen(false);
    setArtprintsSubmenuOpen(false);
  };

  const handleLogoClick = () => {
    // Clear all category-specific lastViewedImageId keys from sessionStorage when logo is clicked
    const storageKeys = [
      'lastViewedImageIdWallcoveringdecorative',
      'lastViewedImageIdWallcoveringabstract',
      'lastViewedImageIdWallcoveringCorporate',
      'lastViewedImageIdWallcoveringkids',
      'lastViewedImageIdWallcoveringminimalpattern',
      'lastViewedImageIdWallcoveringviewall',
      'lastViewedImageIdArtprintsabstract',
      'lastViewedImageIdArtprintsDecorative',
      'lastViewedImageIdArtprintsExclusive',
      'lastViewedImageIdArtprintsLandscape',
      'lastViewedImageIdArtprintsViewall',
      'lastViewedImageIdExclusivehandpainting'
    ];

    let clearedCount = 0;
    storageKeys.forEach(key => {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key);
        clearedCount++;
      }
    });

    if (clearedCount > 0) {
      console.log(`[Navbar] Logo clicked - cleared ${clearedCount} lastViewedImageId keys from sessionStorage`);
    }

    window.scrollTo({ top: 0 });
    setIcon(false);
    setWallcoveringsSubmenuOpen(false);
    setArtprintsSubmenuOpen(false);
  };

  const toggleWallcoveringsSubmenu = () => {
    setWallcoveringsSubmenuOpen(!wallcoveringsSubmenuOpen);
    setArtprintsSubmenuOpen(false);
  };

  const toggleArtprintsSubmenu = () => {
    setArtprintsSubmenuOpen(!artprintsSubmenuOpen);
    setWallcoveringsSubmenuOpen(false);
  };

  // Lock body scroll while mobile menu is open to prevent background movement
  useEffect(() => {
    if (icon) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [icon]);

  // Handle clicks outside the mobile menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        icon &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setIcon(false);
        setWallcoveringsSubmenuOpen(false);
        setArtprintsSubmenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [icon]);

  return (
    <>
      <nav className="fixed w-full top-0 left-0 z-50 bg-white shadow-md font-serif">
        <div className="mx-auto px-4 sm:px-6 h-16 w-full bg-white">
          <div className="flex items-center h-full">
            {/* Logo */}
            <Link to="/" className="mr-auto" onClick={handleLogoClick}>
              <img
                src={logo}
                alt="Logo"
                className="h-12 w-auto transition-transform duration-300 hover:scale-105 sm:h-10"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-10">
              {/* Wallcoverings Dropdown */}
              <div className="relative group">
                <button
                  className="flex items-center space-x-2 text-gray-700 group-hover:text-yellow-600 font-medium 
                    transition-all duration-300 py-2 group-hover:scale-105"
                  onMouseEnter={() => setWallcoveringsSubmenuOpen(true)}
                  onMouseLeave={(e) => {
                    if (!e.relatedTarget?.closest('.wallcoverings-submenu')) {
                      setWallcoveringsSubmenuOpen(false);
                    }
                  }}
                >
                  <span className="text-base tracking-wide font-serif">Wall Papers</span>
                  <FaChevronDown className={`w-4 h-4 transition-transform duration-300 
                    ${wallcoveringsSubmenuOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`absolute top-full -left-4 mt-2 py-3 bg-white rounded-xl 
                    shadow-xl wallcoverings-submenu border border-gray-100 font-serif
                    transition-all duration-300 transform origin-top min-w-[200px] z-50
                    ${wallcoveringsSubmenuOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0 invisible'}`}
                  onMouseEnter={() => setWallcoveringsSubmenuOpen(true)}
                  onMouseLeave={() => setWallcoveringsSubmenuOpen(false)}
                >
                  {["Decorative", "Abstract", "Corporate", "Kids", "Minimal and Pattern"].map((item) => (
                    <Link
                      key={item}
                      to={`/wallcoverings/${item.toLowerCase()}`}
                      className="block px-6 py-2.5 text-gray-700 hover:bg-yellow-50/80 hover:text-yellow-600 
                        text-base transition-colors duration-200"
                      onClick={handleLinkClick}
                    >
                      {item}
                    </Link>
                  ))}
                  <div className="mx-6 mt-2 border-t border-dotted border-gray-300"></div>
                  <Link
                    to="/wallcoverings"
                    className="block px-6 py-2.5 text-gray-700 hover:bg-yellow-50/80 hover:text-yellow-600 
                      text-base transition-colors duration-200 font-serif"
                    onClick={handleLinkClick}
                  >
                    View All
                  </Link>
                </div>
              </div>

              {/* Art Prints Dropdown */}
              <div className="relative group">
                <button
                  className="flex items-center space-x-2 text-gray-700 group-hover:text-yellow-600 font-medium 
                    transition-all duration-300 py-2 group-hover:scale-105"
                  onMouseEnter={() => setArtprintsSubmenuOpen(true)}
                  onMouseLeave={(e) => {
                    if (!e.relatedTarget?.closest('.artprints-submenu')) {
                      setArtprintsSubmenuOpen(false);
                    }
                  }}
                >
                  <span className="text-base tracking-wide font-serif">Art Prints</span>
                  <FaChevronDown className={`w-4 h-4 transition-transform duration-300 
                    ${artprintsSubmenuOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`absolute top-full -left-4 mt-2 py-3 bg-white rounded-xl 
                    shadow-xl artprints-submenu border border-gray-100 font-serif
                    transition-all duration-300 transform origin-top min-w-[200px] z-50
                    ${artprintsSubmenuOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0 invisible'}`}
                  onMouseEnter={() => setArtprintsSubmenuOpen(true)}
                  onMouseLeave={() => setArtprintsSubmenuOpen(false)}
                >
                  {[
                    "Abstract",
                    "Decorative",
                    "Exclusive",
                    "Landscape",
                    "Set of 2 and 3",
                  ].map((item) => (
                    <Link
                      key={item}
                      to={`/artprints/${item.toLowerCase()}`}
                      className="block px-6 py-2.5 text-gray-700 hover:bg-yellow-50/80 hover:text-yellow-600 
                        text-base transition-colors duration-200"
                      onClick={handleLinkClick}
                    >
                      {item}
                    </Link>
                  ))}
                  <div className="mx-6 mt-2 border-t border-dotted border-gray-300"></div>
                  <Link
                    to="/artprints"
                    className="block px-6 py-2.5 text-gray-700 hover:bg-yellow-50/80 hover:text-yellow-600 
                      text-base transition-colors duration-200 font-serif"
                    onClick={handleLinkClick}
                  >
                    View All
                  </Link>
                </div>
              </div>

              {/* Other Navigation Links */}
              {[
                { to: "/exclusivehandpaintings", text: "Hand Paintings" },
                { to: "/customiseyourproject", text: "Customise Project" },
                // { to: "/artshows", text: "Art Shows" },
                { to: "/aboutus", text: "About Us" }
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-base text-gray-700 hover:text-yellow-600 font-medium tracking-wide
                    transition-all duration-300 hover:scale-105 py-2"
                >
                  {link.text}
                </Link>
              ))}

              {/* Wishlist Icon */}
              <Link
                to="/wishlist"
                className="relative text-gray-700 hover:text-red-500 transition-all duration-300 hover:scale-110 py-2"
                title="Wishlist"
              >
                <FaHeart className="w-5 h-5" />
                {getWishlistCount() > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                    {getWishlistCount() > 9 ? '9+' : getWishlistCount()}
                  </span>
                )}
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIcon(!icon)}
              className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 
                transition-colors duration-300 hover:text-yellow-600"
              aria-label="Toggle menu"
              ref={menuButtonRef}
            >
              {icon ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Drawer */}
        <div
          className={`fixed inset-y-0 right-0 h-full w-80 sm:w-96 max-w-[90vw] bg-[#FAF8F5] font-serif
            shadow-2xl transform transition-transform duration-300 ease-in-out md:hidden flex flex-col
            z-50 border-l border-[#EBE6DC]
            ${icon ? 'translate-x-0' : 'translate-x-full'}`}
          ref={mobileMenuRef}
        >
          {/* Mobile Drawer Header with Logo & Close Button */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-[#ECE7DC]">
            <Link to="/" onClick={handleLogoClick} className="flex items-center">
              <img
                src={logo}
                alt="VIZAURA"
                className="h-8 sm:h-9 w-auto object-contain"
              />
            </Link>
            <button
              onClick={() => {
                setIcon(false);
                setWallcoveringsSubmenuOpen(false);
                setArtprintsSubmenuOpen(false);
              }}
              className="p-2 text-[#1E2837] hover:bg-[#EBE6DC] rounded-full transition-colors duration-200"
              aria-label="Close menu"
            >
              <FaTimes className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile Nav Menu Items */}
          <div className="flex-1 overflow-y-auto px-5 py-5 space-y-3 no-scrollbar">
            {/* Mobile Wallcoverings Pill Dropdown */}
            <div>
              <button
                onClick={toggleWallcoveringsSubmenu}
                className={`w-full flex items-center justify-between px-6 py-3.5 rounded-2xl transition-all duration-300 font-serif text-[15px] sm:text-base font-medium tracking-wide ${wallcoveringsSubmenuOpen
                    ? "bg-[#1E2837] text-white shadow-md"
                    : "bg-[#F4F1EA] text-[#2B3442] hover:bg-[#EBE6DC]"
                  }`}
              >
                <span>Wall Papers</span>
                <FaChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${wallcoveringsSubmenuOpen ? "rotate-180 text-white" : "text-[#2B3442]"
                    }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${wallcoveringsSubmenuOpen ? "max-h-[600px] opacity-100 mt-2 mb-1" : "max-h-0 opacity-0"
                  }`}
              >
                <div className="bg-white/70 backdrop-blur-xs rounded-2xl p-2.5 border border-[#E8E3D9] space-y-1">
                  {["Decorative", "Abstract", "Corporate", "Kids", "Minimal and Pattern"].map((item) => (
                    <Link
                      key={item}
                      to={`/wallcoverings/${item.toLowerCase()}`}
                      className="flex items-center px-3 py-2 rounded-xl text-[#2B3442] hover:text-yellow-700 hover:bg-[#F4F1EA] transition-all duration-200 text-sm font-serif group"
                      onClick={handleLinkClick}
                    >
                      <CategoryRotatingThumbnail images={WALLPAPER_THUMBNAILS[item]} alt={item} />
                      <span className="font-serif group-hover:translate-x-1 transition-transform duration-200">
                        {item}
                      </span>
                    </Link>
                  ))}
                  <div className="mx-2 my-1 border-t border-dotted border-[#D8D2C6]"></div>
                  <Link
                    to="/wallcoverings"
                    className="flex items-center px-3 py-2 rounded-xl text-[#2B3442] hover:text-yellow-700 hover:bg-[#F4F1EA] transition-all duration-200 text-sm font-semibold group"
                    onClick={handleLinkClick}
                  >
                    <CategoryRotatingThumbnail images={WALLPAPER_THUMBNAILS["View All"]} alt="View All" />
                    <span className="font-serif group-hover:translate-x-1 transition-transform duration-200">
                      View All
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Mobile Art Prints Pill Dropdown */}
            <div>
              <button
                onClick={toggleArtprintsSubmenu}
                className={`w-full flex items-center justify-between px-6 py-3.5 rounded-2xl transition-all duration-300 font-serif text-[15px] sm:text-base font-medium tracking-wide ${artprintsSubmenuOpen
                    ? "bg-[#1E2837] text-white shadow-md"
                    : "bg-[#F4F1EA] text-[#2B3442] hover:bg-[#EBE6DC]"
                  }`}
              >
                <span>Art Prints</span>
                <FaChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${artprintsSubmenuOpen ? "rotate-180 text-white" : "text-[#2B3442]"
                    }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${artprintsSubmenuOpen ? "max-h-[600px] opacity-100 mt-2 mb-1" : "max-h-0 opacity-0"
                  }`}
              >
                <div className="bg-white/70 backdrop-blur-xs rounded-2xl p-2.5 border border-[#E8E3D9] space-y-1">
                  {[
                    "Abstract",
                    "Decorative",
                    "Exclusive",
                    "Landscape",
                    "Set of 2 and 3",
                  ].map((item) => (
                    <Link
                      key={item}
                      to={`/artprints/${item.toLowerCase()}`}
                      className="flex items-center px-3 py-2 rounded-xl text-[#2B3442] hover:text-yellow-700 hover:bg-[#F4F1EA] transition-all duration-200 text-sm font-serif group"
                      onClick={handleLinkClick}
                    >
                      <CategoryRotatingThumbnail images={ARTPRINT_THUMBNAILS[item]} alt={item} />
                      <span className="font-serif group-hover:translate-x-1 transition-transform duration-200">
                        {item}
                      </span>
                    </Link>
                  ))}
                  <div className="mx-2 my-1 border-t border-dotted border-[#D8D2C6]"></div>
                  <Link
                    to="/artprints"
                    className="flex items-center px-3 py-2 rounded-xl text-[#2B3442] hover:text-yellow-700 hover:bg-[#F4F1EA] transition-all duration-200 text-sm font-semibold group"
                    onClick={handleLinkClick}
                  >
                    <CategoryRotatingThumbnail images={ARTPRINT_THUMBNAILS["View All"]} alt="View All" />
                    <span className="font-serif group-hover:translate-x-1 transition-transform duration-200">
                      View All
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            {/* Other Mobile Links (Capsule Pills) */}
            {[
              { to: "/exclusivehandpaintings", text: "Exclusive Hand Paintings" },
              { to: "/customiseyourproject", text: "Customise Your Project" },
              // { to: "/artshows", text: "Art Shows" },
              { to: "/aboutus", text: "About Us" },
            ].map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="w-full flex items-center px-6 py-3.5 rounded-2xl bg-[#F4F1EA] hover:bg-[#EBE6DC] text-[#2B3442] font-serif text-[15px] sm:text-base font-medium tracking-wide transition-all duration-300"
                onClick={handleLinkClick}
              >
                {link.text}
              </Link>
            ))}

            {/* Mobile Wishlist Pill */}
            <Link
              to="/wishlist"
              className="w-full flex items-center justify-between px-6 py-3.5 rounded-2xl bg-[#F4F1EA] hover:bg-[#EBE6DC] text-[#2B3442] font-serif text-[15px] sm:text-base font-medium tracking-wide transition-all duration-300"
              onClick={handleLinkClick}
            >
              <div className="flex items-center gap-3">
                <FaHeart className="w-4 h-4 text-[#1E2837]" />
                <span>Wishlist</span>
              </div>
              {getWishlistCount() > 0 && (
                <span className="bg-[#1E2837] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {getWishlistCount() > 9 ? "9+" : getWishlistCount()}
                </span>
              )}
            </Link>
          </div>
        </div>
      </nav>

      {/* Full-screen Backdrop overlay for mobile menu */}
      {icon && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity duration-300 backdrop-blur-xs"
          onClick={() => {
            setIcon(false);
            setWallcoveringsSubmenuOpen(false);
            setArtprintsSubmenuOpen(false);
          }}
        />
      )}
    </>
  );
};

export default Navbar;





























//  {/* <li onClick={() => seticon(!icon)}><a href="#services">Services</a></li> */}
// {/* <li onClick={() => seticon(!icon)}><a href="#why">Why Choose Us</a></li> */}
// {/* <li onClick={() => seticon(!icon)}><a href="#team">Team</a></li> */}
// {/* <li onClick={() => seticon(!icon)}><a href="#testimonial">Testimonial</a></li> */}
// {/* <li className="font-bold" onClick={() => seticon(!icon)}><a href="/contactus">Contacts</a></li> */}
// {/* <li onClick={() => seticon(!icon)}><a href="#news">News</a></li> */}
// {/* Add other links here */}